@if (unregisteredUser) {
  <div class="container single-view" id="edit-unregistered-user">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/unregistered-users/' + unregisteredUserId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'UNREGISTERED_USERS.BTN_BACK_TO_UNREGISTERED_USER' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-unregistered-user-title" class="section-title">{{ 'UNREGISTERED_USER_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <form class="mt-0" [formGroup]="unregisteredUserForm" data-testid="edit-unregistered-user-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="edit-unregistered-user-details" class="border-b pb-3">{{ 'UNREGISTERED_USER_UPDATE.USER_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-unregistered-user-field-firstname" class="block text-sm" for="firstname">{{ 'UNREGISTERED_USER_UPDATE.FIRST_NAME' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-unregistered-user-firstname-input" type="text" formControlName="firstname" autocomplete="off">
                    @if (unregisteredUserForm.get('firstname')?.invalid && (unregisteredUserForm.get('firstname')?.touched || unregisteredUserForm.get('firstname')?.dirty)) {
                      <small data-testid="firstname-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-unregistered-user-field-romanisedfirstname" class="block text-sm" for="romanisedFirstName">{{ 'UNREGISTERED_USER_UPDATE.ROMANISED_FIRST_NAME' | translate }}</label>
                    <input data-testid="edit-unregistered-user-romanisedfirstname-input" type="text" formControlName="romanisedFirstName" autocomplete="off">
                    @if (unregisteredUserForm.get('romanisedFirstName')?.invalid && (unregisteredUserForm.get('romanisedFirstName')?.dirty || unregisteredUserForm.get('romanisedFirstName')?.touched)) {
                      @if (unregisteredUserForm.get('romanisedFirstName')?.errors?.['invalidCharacters']) {
                        <small data-testid="romanisedfirstname-format" class="p-error">
                          {{ 'UNREGISTERED_USER_UPDATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                        </small>
                      }
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-unregistered-user-field-lastname" class="block text-sm" for="lastname">{{ 'UNREGISTERED_USER_UPDATE.LAST_NAME' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-unregistered-user-lastname-input" type="text" formControlName="lastname" autocomplete="off">
                    @if (unregisteredUserForm.get('lastname')?.invalid && (unregisteredUserForm.get('lastname')?.touched || unregisteredUserForm.get('lastname')?.dirty)) {
                      <small data-testid="lastname-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-unregistered-user-field-romanisedlastname" class="block text-sm" for="romanisedLastName">{{ 'UNREGISTERED_USER_UPDATE.ROMANISED_LAST_NAME' | translate }}</label>
                    <input data-testid="edit-unregistered-user-romanisedlastname-input" type="text" formControlName="romanisedLastName" autocomplete="off">
                    @if (unregisteredUserForm.get('romanisedLastName')?.invalid && (unregisteredUserForm.get('romanisedLastName')?.dirty || unregisteredUserForm.get('romanisedLastName')?.touched)) {
                      @if (unregisteredUserForm.get('romanisedLastName')?.errors?.['invalidCharacters']) {
                        <small data-testid="romanisedlastname-format" class="p-error">
                          {{ 'UNREGISTERED_USER_UPDATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                        </small>
                      }
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="flex flex-col col-12 mb-4 mt-4">
                    <h2 data-testid="edit-unregistered-user-retailers-details" class="border-b pb-3">{{ 'UNREGISTERED_USER_UPDATE.UNREGISTERED_USER_RETAILERS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-unregistered-user-field-retailers" class="block text-sm" for="retailerIds">{{ 'UNREGISTERED_USER_UPDATE.ASSIGN_RETAILERS' | translate }} <i class="icon-required-field"></i></label>
                    <app-custom-dropdown
                      data-testid="retailers"
                      [placeholder]="'UNREGISTERED_USER_UPDATE.SELECT_RETAILERS' | translate"
                      [fieldLabel]="'UNREGISTERED_USER_UPDATE.ASSIGN_RETAILERS' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="true"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="retailersRowsPerPageOption"
                      [totalCount]="retailersTotalRecords"
                      [totalPages]="getTotalPages(retailersTotalRecords, retailersRowsPerPageOption)"
                      [options]="retailersList"
                      formControlName="retailerIds"
                      (onLazyLoad)="onLazyLoadRetailers($event)">
                    </app-custom-dropdown>
                    @if (unregisteredUserForm.get('retailerIds')?.invalid && unregisteredUserForm.get('retailerIds')?.touched) {
                      <small data-testid="retailers-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-unregistered-user-update-button" class="btn primary-btn" [disabled]="isSubmitDisabled()" (click)="submitForm()">{{
                      'UNREGISTERED_USER_UPDATE.BTN_UPDATE_UNREGISTERED_USER' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
